module.exports = __webpack_public_path__ + "img/upi_long.7d798c38.svg";